import React from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import ManagerBodyMapBoy from "../../../managerSafeGuarding/BodyMapSafeGuardingManager/manager-body-map-boy";
import ManagerBodyMapGirl from "../../../managerSafeGuarding/BodyMapSafeGuardingManager/manager-body-map-girl";

const BodyMapBriefManager = ({ bodayMapData, nextStep, prevStep, gender }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store

 

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>
        Child and Young Person Debrief
      </Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />
      <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "#333", mb: 2 }}>
        Mark in the image any area where you were held
      </Typography>

      {gender === "Male" ? (
        <ManagerBodyMapBoy onUpload={() => {}} uploadedImages={bodayMapData} />
      ) : gender === "Female" ? (
        <ManagerBodyMapGirl onUpload={() => {}} uploadedImages={bodayMapData} />
      ) : (
        <></>
      )}
      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,

          padding: 2,
          zIndex: 10,
        }}
      >
        <Button variant='outlined' color='primary' onClick={prevStep}>
          Previous
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            nextStep(); // Call the function properly
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default BodyMapBriefManager;
